<div class="tab-header-group no-select u-scrollbox-x">
  <ng-container *ngFor="let tab of tabs">
    <div *ngIf="tab.enabled" class="tab-header"
        [class.tab-header-active]="activeTab && tab.id === activeTab.id"
        (click)="onTabClick(tab)"
        [title]=tab.caption>
      <p class="tab-title nav-font">{{tab.caption}}</p>
      <div
        *ngIf="tab.closeable"
        class="tab-close-image"
        [class.tab-header-active]="activeTab && tab.id === activeTab.id"
        (click)="onCloseTab(tab)"
      ></div>
  </div>
  </ng-container>
</div>



